export default {
  GET_ALLIANZ_POLICY_ISSUANCE_STATUS_QUERY: Symbol.for('GET_ALLIANZ_POLICY_ISSUANCE_STATUS_QUERY'),
  ALLIANZ_POLICY_ISSUANCE_STATUS_REPOSITORY: Symbol.for('ALLIANZ_POLICY_ISSUANCE_STATUS_REPOSITORY'),
  PATCH_ALLIANZ_POLICY_ISSUANCE_STATUS_COMMAND: Symbol.for('PATCH_ALLIANZ_POLICY_ISSUANCE_STATUS_COMMAND'),
  PATCH_ALLIANZ_POLICY_ISSUANCE_STATUS_REPOSITORY: Symbol.for('PATCH_ALLIANZ_POLICY_ISSUANCE_STATUS_REPOSITORY'),
  ALLIANZ_POLICY_ISSUANCE_STATUS_STATE_MANAGER: Symbol.for('ALLIANZ_POLICY_ISSUANCE_STATUS_STATE_MANAGER'),
};
